//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientProfileNameLabel from "@Broker/@Modules/clients/board/client-profile/components/shared/client-profile-name-label.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MergeClientProfileWarning",
  components: {
    ClientProfileNameLabel
  },
  props: {
    clientProfileOrigin: {
      type: Object,
      default: () => ({})
    },
    clientProfileToMerge: {
      type: Object,
      default: () => ({})
    },
    textClass: {
      type: String,
      default: "text-danger"
    },
    showProfileIndicator: {
      type: Boolean,
      default: false
    }
  }
});